module.exports = __webpack_public_path__ + "static/Nanopesos1-f570d1b58e8daa4036fdf2ad5f559594.png";